var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5663 6.88688L17.113 4.43356C16.535 3.85553 15.5994 3.85543 15.0213 4.43356C14.6098 4.84509 5.56382 13.8911 5.39129 14.0636C5.3231 14.1318 5.27488 14.2173 5.25191 14.311L4.01557 19.3459C3.92069 19.7324 4.27138 20.0784 4.65404 19.9844C4.91532 19.9203 9.45773 18.8048 9.68895 18.748C9.78257 18.7251 9.86813 18.6768 9.93629 18.6087C10.118 18.4269 19.1137 9.43123 19.5663 8.9786C20.1443 8.40057 20.1445 7.46497 19.5663 6.88688ZM5.24854 18.7514L5.29891 18.5463L5.45363 18.701L5.24854 18.7514ZM6.6522 18.4067L5.59323 17.3478L6.05373 15.4725L8.52748 17.9462L6.6522 18.4067ZM9.56307 17.489L6.51095 14.4369L14.3924 6.55541L17.4445 9.60754L9.56307 17.489ZM18.8199 8.23216L18.2103 8.84176L15.1582 5.78963L15.7678 5.18003C15.9332 5.01462 16.2011 5.01447 16.3666 5.18003L18.8199 7.63338C18.9854 7.79885 18.9854 8.06663 18.8199 8.23216Z",
    fill: "#114BC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ba5967fa1e7e090b5603d587d3e9f7ed.svg";
export { ForwardRef as ReactComponent };